import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { IEndUserCategoryList } from '@components/onetoonemeetings';
import { ErrorHandler } from '@helper/errorHandler';

export const useEndUserCategoryList = (): IQueryResponse<IEndUserCategoryList[]> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('enduser_category_list');
	const fetchEndUserCategoryList = async (): Promise<[]> => {
		try {
			const response = await APIService.getData<[]>(APICONFIG.END_USER_CATEGORY_LIST, {
				limit: '0',
			});
			if (response) {
				await setRxdb('enduser_category_list', response);
			}
			return response;
		} catch (error) {
			ErrorHandler(error);
			return [];
		}
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['enduserCategoryList'],
		queryFn: fetchEndUserCategoryList,
		enabled: isDbChecked && shouldFetch,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
